<template>
  <div class="e-card">
    <div class="e-card__container">
      <b-tabs ref="bTabs" nav-wrapper-class="e-card__header" nav-class="e-card__nav-tabs" content-class="e-card__nav-item">
        <slot/>
      </b-tabs>
      <e-card-header v-if="controls" ref="tHeader" @move="handleMove"/>
    </div>
  </div>

</template>

<script>
  import ECardHeader from './cardHeader';

	export default {
		name: "e-card",
    components: {ECardHeader},
    props: {
		  controls: {
		    type: Boolean,
        default: true,
      }
    },
    methods: {
      handleMove(v) {
        this.$emit('toggleDrag');
      }
    },

    mounted() {
		  if(this.controls) {
        const tHeader = this.$refs.tHeader;
        const $header = this.$refs.bTabs.$el.querySelector('.e-card__header');

        $header.appendChild(tHeader.$el);
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/card/card.vue